import { Input } from './Input';

export const Form = {
  Input,
};
